import {type CallPut, type Symbol, type WireProductSymbol} from './common';

// eslint-disable-next-line @typescript-eslint/no-restricted-types -- Subscription schemas preserve explicit JSON null values.
type NullValue = null;

export type InventoryRecord = {
  key: string;
  account: string;
  qepSymbol: string;
  unqiueSymbol: string;
  contractSymbol: string;
  rootSymbol: string;
  currentPosition: number;
  totalTraded: number;
  buyAveragePrice: number;
  sellAveragePrice: number;
  buyTotalTraded: number;
  sellTotalTraded: number;
  exchange?: string;
  secType?: string;
  description?: string;
  contractMultiplier?: number;
  contractUnits?: string;
  maturity?: Date;
  symbol: Symbol;
  clearingString: string;
  usedOrders?: string[];
  precision?: number;
  businessUnit?: string;
  strikePrice?: number;
  callPut?: CallPut;
};

export enum InventoryEvent {
  INITIAL = 'INITIAL',
  UPDATE = 'UPDATE',
  RESET = 'RESET',
}
export type InventoryPayload = {
  topic: InventoryEvent;
  payload: InventoryRecord | InventoryRecord[];
};

/** One schema-validated inventory record delivered by the preload subscription. */
export type InventorySubscriptionRecord = {
  account: string;
  businessUnit?: string | NullValue;
  buyAveragePrice?: number | NullValue;
  buyTotalTraded?: number | NullValue;
  clearingString: string;
  currentPosition?: number | NullValue;
  key: string;
  precision?: string | number | NullValue;
  rootSymbol: string;
  sellAveragePrice?: number | NullValue;
  sellTotalTraded?: number | NullValue;
  strikePrice?: number | NullValue;
  symbol: WireProductSymbol;
  totalTraded?: number | NullValue;
  unqiueSymbol: string;
  usedOrders: string[];
};

/** Validated initial or incremental inventory subscription update. */
export type InventorySubscriptionUpdate = {
  payload: InventorySubscriptionRecord[];
  topic: 0 | 1;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export type InventoryWPL = {
  monrningPL: number;
  newPL: number;
  totalPL: number;
  buyPL: number;
  sellPL: number;
} & InventoryRecord;
